// src/features/audit/components/AuditTargetCard.tsx
import { Card } from '../../../app/components/foundation';
import type { AuditTarget } from '../data/audit.mock';

export interface AuditTargetCardProps {
  target: AuditTarget | undefined;
}

/**
 * Workspace card: what this audit event acted on — target type, its
 * id, and its display name. `target` comes from
 * useAuditWorkspaceMock. Same field-list markup as
 * security/components/SecurityPolicyCard.tsx.
 */
export function AuditTargetCard({ target }: AuditTargetCardProps) {
  return (
    <Card className="vania-audit-workspace-card">
      <h2 className="vania-audit-workspace-card-title">هدف رخداد</h2>

      {!target ? (
        <p className="vania-audit-workspace-empty">هدفی برای این رخداد ثبت نشده است.</p>
      ) : (
        <dl className="vania-audit-workspace-fieldlist">
          <div>
            <dt>نوع هدف</dt>
            <dd>{target.targetType}</dd>
          </div>
          <div>
            <dt>شناسه هدف</dt>
            <dd dir="ltr">{target.targetId}</dd>
          </div>
          <div>
            <dt>نام هدف</dt>
            <dd>{target.targetName}</dd>
          </div>
        </dl>
      )}
    </Card>
  );
}
